var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHighschool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 492,
    viewBox: "0 0 492 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1107_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.44 245.754H174.08V307.194H317.44V245.754Z",
    fill: "#062134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.378 403.517C436.078 401.797 437.307 399.81 438.29 397.721C438.577 397.107 438.741 396.451 438.966 395.796C439.58 394.035 439.949 392.233 440.072 390.348C440.092 389.918 440.318 389.549 440.318 389.119V20.48C440.318 9.175 431.163 0 419.838 0H235.518V143.36C235.518 151.573 230.603 159.007 223.046 162.202C220.465 163.308 217.742 163.84 215.038 163.84C209.836 163.84 204.696 161.853 200.825 158.085L174.078 132.28L147.331 158.085C141.453 163.799 132.667 165.437 125.11 162.201C117.553 159.006 112.638 151.572 112.638 143.359V0H102.767C74.3193 0 51.1973 23.122 51.1973 51.548V430.08C51.1973 463.954 78.7633 491.52 112.637 491.52H419.837C428.111 491.52 435.586 486.523 438.761 478.884C441.935 471.224 440.174 462.418 434.317 456.561C415.025 437.269 415.025 422.912 434.317 403.62C434.337 403.579 434.357 403.538 434.378 403.517ZM133.117 225.28C133.117 213.975 142.272 204.8 153.597 204.8H337.917C349.242 204.8 358.397 213.975 358.397 225.28V327.68C358.397 338.985 349.242 348.16 337.917 348.16H153.597C142.272 348.16 133.117 338.985 133.117 327.68V225.28ZM382.4 450.56H112.637C101.332 450.56 92.1573 441.365 92.1573 430.08C92.1573 418.795 101.332 409.6 112.637 409.6H382.4C377.771 423.178 377.771 436.982 382.4 450.56Z",
    fill: "#062134"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1107_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 491.52,
    height: 491.52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHighschool);
export default __webpack_public_path__ + "static/media/ico_highschool.9d6f2f44da277b9937ac218fe2a94741.svg";
export { ForwardRef as ReactComponent };